import { FunctionComponent, ReactElement, ReactNode } from 'react';
import { Card, Typography, Divider } from '@mui/material';
import LeviantLogo from '@/assets/logos/LeviantLogo';
import './auth-card-layout.scss';

interface AuthCardLayoutProps {
	title: string;
	children: ReactNode;
}

const AuthCardLayout: FunctionComponent<AuthCardLayoutProps> = ({
	title,
	children,
}): ReactElement => (
	<Card className="auth-card" elevation={1}>
		<LeviantLogo />
		<Typography component="h1" variant="h4" mt={3} mb={3}>
			{title}
		</Typography>
		<Divider />
		{children}
	</Card>
);

export default AuthCardLayout;
